export const authConstants = {
  storageAccessTokenKey: "accessToken",
  storageRefreshTokenKey: "refreshToken",
  refreshTokenExpiredEventKey: "refreshToken_expired",
};
